import {
  resolveMinMax,
  resolveMinMaxDescription,
  resolveIdDescriptor,
  resolveDoubtfulDescription,
} from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    sourceDay,
    sourceMonth,
    sourceMinYear,
    sourceMaxYear,
    sourceRegionCode,
    sourceCountry,
    sourceArea,
    sourceMinEventValidity,
    sourceMaxEventValidity,
    sourceMinCauseCode,
    sourceMaxCauseCode,
    sourceMinEqMagnitude,
    sourceMaxEqMagnitude,
    sourceOceanicTsunami,
    regionCode,
    country,
    area,
    minDistFromSource,
    maxDistFromSource,
    minLatitude,
    maxLatitude,
    minLongitude,
    maxLongitude,
    typeMeasurementId,
    minRunupHt,
    maxRunupHt,
    minDeaths,
    maxDeaths,
    minDeathsAmountOrder,
    maxDeathsAmountOrder,
    minDamageMillionsDollars,
    maxDamageMillionsDollars,
    minDamageAmountOrder,
    maxDamageAmountOrder,
    minInjuries,
    maxInjuries,
    minInjuriesAmountOrder,
    maxInjuriesAmountOrder,
    minHousesDestroyed,
    maxHousesDestroyed,
    minHousesDestroyedAmountOrder,
    maxHousesDestroyedAmountOrder,
    minHousesDamaged,
    maxHousesDamaged,
    minHousesDamagedAmountOrder,
    maxHousesDamagedAmountOrder,
    minTravHours,
    maxTravHours,
    doubtful,
    minRunupHoriz,
    maxRunupHoriz,
    locStart,
    locInclude,
    locMatch,
    locNot,
    commentsStart,
    commentsInclude,
    commentsMatch,
    commentsNot,
    tsunamiEventId,
    minEventId,
    maxEventId,
    minTroughHt,
    maxTroughHt,

  },
  regions,
  runupRegions,
  peopleDescriptors,
  damageDescriptors,
  housesDescriptors,
  validities,
  causes,
  runupMeasurementTypes,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  if (sourceDay != null) {
    messages.push(`Day = ${sourceDay}`);
  }

  if (sourceMonth != null) {
    messages.push(`Month = ${sourceMonth}`);
  }

  resolveMinMax('Year', sourceMinYear, sourceMaxYear, messages);

  resolveMinMax('ID', minId, maxId, messages);

  if (sourceRegionCode != null) {
    const region = sourceRegionCode.split(',').map(s => resolveIdDescriptor(regions, s)).join(';');
    messages.push(`Source Region = ${region}`);
  }

  if (sourceCountry != null) {
    messages.push(`Source Country = ${sourceCountry}`);
  }

  if (sourceArea != null) {
    messages.push(`Source Area = ${sourceArea}`);
  }

  resolveMinMaxDescription('Source Validity', sourceMinEventValidity, sourceMaxEventValidity, validities, messages);

  resolveMinMaxDescription('Source Cause', sourceMinCauseCode, sourceMaxCauseCode, causes, messages);

  resolveMinMax('Earthquake Magnitude', sourceMinEqMagnitude, sourceMaxEqMagnitude, messages);

  if (sourceOceanicTsunami != null) {
    messages.push(`Oceanic Tsunami = ${sourceOceanicTsunami}`);
  }

  if (regionCode != null) {
    const region = regionCode.split(',').map(s => resolveIdDescriptor(runupRegions, s)).join(';');
    messages.push(`Region = ${region}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (area != null) {
    messages.push(`Area = ${area}`);
  }

  resolveMinMax('Distance from Source', minDistFromSource, maxDistFromSource, messages);

  resolveMinMax('Travel Time (Hours)', minTravHours, maxTravHours, messages);

  if (typeMeasurementId != null) {
    const measureType = typeMeasurementId.split(',').map(s => resolveIdDescriptor(runupMeasurementTypes, s)).join(';');
    messages.push(`Measurement Type = ${measureType}`);
  }

  resolveMinMax('Runup Height', minRunupHt, maxRunupHt, messages);
  resolveMinMax('Maximum Trough Height', minTroughHt, maxTroughHt, messages);
  resolveMinMax('Maximum Inundation Distance', minRunupHoriz, maxRunupHoriz, messages);

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);
  resolveMinMax('Longitude', minLongitude, maxLongitude, messages);

  resolveMinMax('Deaths', minDeaths, maxDeaths, messages);
  resolveMinMaxDescription('Deaths Description', minDeathsAmountOrder, maxDeathsAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Injuries', minInjuries, maxInjuries, messages);
  resolveMinMaxDescription('Injuries Description', minInjuriesAmountOrder, maxInjuriesAmountOrder, peopleDescriptors, messages);

  resolveMinMax('Houses Destroyed', minHousesDestroyed, maxHousesDestroyed, messages);
  resolveMinMaxDescription('Houses Destroyed Description', minHousesDestroyedAmountOrder, maxHousesDestroyedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Houses Damaged', minHousesDamaged, maxHousesDamaged, messages);
  resolveMinMaxDescription('Houses Damaged Description', minHousesDamagedAmountOrder, maxHousesDamagedAmountOrder, housesDescriptors, messages);

  resolveMinMax('Damage Millions $', minDamageMillionsDollars, maxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Damage Description', minDamageAmountOrder, maxDamageAmountOrder, damageDescriptors, messages);

  if (doubtful != null) {
    const d = doubtful.split(',').map(s => resolveDoubtfulDescription(doubtful, s)).join(';');
    messages.push(`Doubtfulness = ${d}`);
    // const d = doubtful.toLocaleLowerCase();
    // switch (d) {
    //   case 'n':
    //     messages.push('Doubtfulness = OK');
    //     break;
    //   case 'y':
    //     messages.push('Doubtfulness = Doubtful');
    //     break;
    //   case 'm':
    //     messages.push('Doubtfulness = Meteorological');
    //     break;
    //   case 'a':
    //     messages.push('Doubtfulness = Atmospheric');
    //     break;
    //   default:
    //     break;
    // }
  }

  if (commentsStart != null) {
    messages.push(`Comments start with '${commentsStart}'`);
  }

  if (commentsMatch != null) {
    messages.push(`Comments = '${commentsMatch}'`);
  }

  if (commentsInclude != null) {
    messages.push(`Comments contains '${commentsInclude}'`);
  }

  if (commentsNot != null) {
    messages.push(`Comments != '${commentsNot}'`);
  }

  if (tsunamiEventId != null) {
    messages.push(`Tsunami ID ='${tsunamiEventId}'`);
  }
  resolveMinMax('Tsunami ID', minEventId, maxEventId, messages);
  return messages;
};
